var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.52 27.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0a4f00;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2,.cls-5{fill:#1a1a18;}.cls-3,.cls-4{fill:none;stroke:#000;stroke-miterlimit:2.61;}.cls-3{stroke-width:0.33px;}.cls-4{stroke-width:0.33px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2@3xh") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.75,22.91H39.9V20.66h2.22v2.25h1.15v-5.2H42.12v1.94H39.9V17.71H38.75ZM36.1,20.84H34.83l.63-1.62Zm-3.33,2.07H34l.43-1.1h2l.45,1.1h1.29L36,17.71H35Zm-5,0h1.14V20.66h2.23v2.25h1.14v-5.2H31.11v1.94H28.88V17.71H27.74Zm-.86-4.79a2.35,2.35,0,0,0-1.6-.54,1.78,1.78,0,0,0-2,1.68c0,1.74,2.44,1.22,2.44,2.18,0,.37-.42.54-.79.54a1.25,1.25,0,0,1-1-.49l-.82.9a2.49,2.49,0,0,0,1.75.65c1.07,0,2-.55,2-1.71,0-1.82-2.39-1.21-2.39-2.16,0-.39.45-.54.77-.54a1.09,1.09,0,0,1,.83.35Zm-5.55,4.79h1.15v-5.2H21.33Zm-3.6-4.23h.75c.42,0,.89.08.89.6s-.54.58-1,.58h-.68Zm-1.14,4.23h1.14V20.83h.57l1.09,2.08h1.37l-1.32-2.2a1.34,1.34,0,0,0,1.12-1.42c0-1.21-.89-1.58-2-1.58h-2Zm-2.65-2.07H12.67l.63-1.62Zm-3.33,2.07h1.26l.44-1.1h2l.44,1.1h1.3l-2.26-5.2h-1Zm-5,0H6.72V20.66H8.94v2.25h1.15v-5.2H8.94v1.94H6.72V17.71H5.57ZM1.15,18.77h.67c1,0,1.79.47,1.79,1.49,0,1.19-.8,1.59-1.87,1.59H1.15ZM0,22.91H1.87a2.65,2.65,0,0,0,2.92-2.59c0-1.9-1.4-2.61-3.07-2.61H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.76,3.37A30,30,0,0,0,21.94,0a28,28,0,0,0-2.82,3.41l2.42,2.31V4.06h.76V5.72Zm-3.22,3.4L18.69,4.05c-3.54,5.41-3.64,10.62,2.85,11.52V13.76l-3.71-3.54.52-.55,3.19,3V10.28L17.82,6.73l.52-.55,3.2,3.05Zm.76,8.79C28.1,14.86,29.15,10,25.19,4L22.3,6.77V9.2l3.19-3L26,6.7,22.3,10.26v2.45l3.18-3,.53.55L22.3,13.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.49,25.23h0c.07.24.18.62.28.92h-.57c.1-.3.21-.68.28-.92m-.62,1.89a.08.08,0,0,0,.07-.05l.13-.43h.85l.13.43a.08.08,0,0,0,.07.05h.47a.05.05,0,0,0,0-.07l-.82-2.38a.06.06,0,0,0-.06-.05h-.53a.08.08,0,0,0-.07.05l-.81,2.38s0,.07,0,.07Zm-3.47-2h.36c.27,0,.41.14.41.43v.61a.36.36,0,0,1-.41.41H30.4Zm.36,2a.87.87,0,0,0,1-1V25.6a.88.88,0,0,0-1-1H29.9s-.07,0-.07.06v2.38s0,.06.07.06Zm-3.88-1h.87a.05.05,0,0,0,.06-.06v-.38s0-.05-.06-.05h-.87v-.48h1a.05.05,0,0,0,.06-.06v-.39a.05.05,0,0,0-.06-.06H26.38a.05.05,0,0,0-.06.06v2.38a.05.05,0,0,0,.06.06h1.54s.07,0,.07-.06v-.39s0-.06-.07-.06h-1Zm-3.16,1a.07.07,0,0,0,.07-.05l.82-2.38a.05.05,0,0,0-.05-.07h-.47a.07.07,0,0,0-.07.05l-.37,1.14c-.07.22-.14.48-.19.68h0c-.05-.2-.12-.47-.19-.69l-.37-1.13a.06.06,0,0,0-.06-.05h-.48a.05.05,0,0,0-.05.07l.82,2.38a.08.08,0,0,0,.07.05Zm-3.95-2c.26,0,.37.1.37.33s-.11.32-.37.32h-.33v-.65Zm1,2c.05,0,.07,0,.05-.07l-.56-.85a.73.73,0,0,0,.5-.74.82.82,0,0,0-.93-.84h-.85a.05.05,0,0,0-.06.06v2.38a.05.05,0,0,0,.06.06h.44a.05.05,0,0,0,.06-.06v-.78h.22l.49.8a.08.08,0,0,0,.07,0Zm-3.79-.92V24.68a.05.05,0,0,0-.06-.06h-.45a.05.05,0,0,0-.06.06V26.2a.38.38,0,0,1-.41.43c-.26,0-.4-.15-.4-.43V24.68a.05.05,0,0,0-.06-.06h-.45a.05.05,0,0,0-.06.06V26.2a.88.88,0,0,0,1,1A.88.88,0,0,0,16.94,26.2Zm-4.48.92a.05.05,0,0,0,.06-.06v-.83l.77-1.54s0-.07,0-.07h-.49a.07.07,0,0,0-.07.05l-.45,1-.46-1a.07.07,0,0,0-.07-.05h-.49s-.06,0,0,.07L12,26.23v.83a.06.06,0,0,0,.06.06Zm-3.7-1.89h0l.27.92H8.49C8.59,25.85,8.69,25.47,8.76,25.23Zm-.61,1.89s0,0,.07-.05l.13-.43H9.2l.13.43a.07.07,0,0,0,.07.05h.46c.05,0,.07,0,.05-.07L9.1,24.67A.06.06,0,0,0,9,24.62H8.51a.07.07,0,0,0-.07.05l-.81,2.38s0,.07,0,.07Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 41.45,
    y1: 26.52,
    x2: 36.82,
    y2: 26.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 43.27,
    y1: 25.89,
    x2: 36.82,
    y2: 25.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 41.45,
    y1: 25.26,
    x2: 36.82,
    y2: 25.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1.82,
    y1: 26.52,
    x2: 6.46,
    y2: 26.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    y1: 25.89,
    x2: 6.46,
    y2: 25.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1.82,
    y1: 25.26,
    x2: 6.46,
    y2: 25.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46,15.18a.91.91,0,0,0-1.29,0,.9.9,0,0,0-.27.65.92.92,0,0,0,1.83,0,.9.9,0,0,0-.27-.65m-.4.44a.16.16,0,0,1-.18.16h-.26v-.33h.26A.17.17,0,0,1,45.63,15.62Zm0,.8h.28L45.63,16a.34.34,0,0,0,.26-.35.37.37,0,0,0-.4-.38h-.55v1.18h.25V16h.18Zm-.23-1.73a1.14,1.14,0,0,1,.81,1.94,1.15,1.15,0,0,1-1.61,0,1.14,1.14,0,0,1,.8-1.94Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.06abf2f33a8ddb775c65b6dc21df7482.svg";
export { ForwardRef as ReactComponent };